/**
 * Optional legacy URL bridge: maps ?concern=<tag> or ?step=<tag> to storefront tag filter params
 * (theme settings: dlux_legacy_redirect_enable, dlux_legacy_tag_filter_param).
 * Enable only after Search & Discovery tag filters are configured and the param name matches your store.
 *
 * - On **collection** templates: rewrites query on the current URL.
 * - On **page** templates (e.g. By Concern / Routine landing pages): redirects to Shop All with the tag filter,
 *   so links like /pages/concerns?concern=hydration reach the filtered catalog.
 */
(function () {
  var cfg = typeof window !== 'undefined' ? window.dluxLegacyRedirect : null;
  if (!cfg || !cfg.enabled) return;

  var u = new URL(window.location.href);
  var concern = (u.searchParams.get('concern') || '').trim();
  var step = (u.searchParams.get('step') || '').trim();
  if (!concern && !step) return;

  var concernParam = 'filter.p.m.custom.concern';
  var stepParam = 'filter.p.m.custom.routine_step';

  if (cfg.template === 'collection') {
    u.searchParams.delete('concern');
    u.searchParams.delete('step');
    if (concern) u.searchParams.append(concernParam, concern);
    if (step) u.searchParams.append(stepParam, step);
    window.location.replace(u.toString());
    return;
  }

  if (cfg.template === 'page' && cfg.pageHandle) {
    var raw = cfg.pageHandlesAllowlist || 'concerns,routine';
    var allow = raw
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
    if (allow.indexOf(String(cfg.pageHandle).toLowerCase()) === -1) return;

    var base = cfg.allProductsCollectionUrl || '/collections/all';
    var target = new URL(base, window.location.origin);
    if (concern) target.searchParams.append(concernParam, concern);
    if (step) target.searchParams.append(stepParam, step);
    window.location.replace(target.toString());
  }
})();
